/* import __COLOCATED_TEMPLATE__ from './play-queue.hbs'; */
import Component from '@glimmer/component';
import { service } from '@ember/service';
import { action } from '@ember/object';

export default class PlayQueueComponent extends Component {
  @service currentlyPlaying;
  @service stickyCalculator;

  get stickyDayTop() {
    //return this.stickyCalculator.top() + document.getElementsByClassName('stickyMainContentHeader')[0].offsetHeight;
    return this.stickyCalculator.top();
  }

  get stickyProjectTop() {
    console.log(
      'stickyProjectTop',
      this.stickyDayTop,
      document.getElementsByClassName('stickyDayHeader')[0].offsetHeight,
    );
    return (
      this.stickyDayTop +
      document.getElementsByClassName('stickyDayHeader')[0].offsetHeight
    );
  }
}
